<template>
  <div class="container-main">
    <div class="d-flex justify-space-between">
      <div class="container-main-header-button">
        <v-btn depressed @click="back">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span>Редактирование события</span>
      </div>
      <div>
        <v-btn
          @click="dialogInfo = true"
          outlined
          color="var(--app-dark-blue-1)"
          width="auto !important"
          class="button-accept-outlined"
        >
          Инструкция к заполнению
        </v-btn>

        <v-dialog width="800px" height="auto" persistent v-model="dialogInfo">
          <v-card>
            <v-card-title class="dialog-title">
              <span class="title">Инструкция к заполнению</span>
              <v-icon @click="dialogInfo = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="dialog-description">
              <v-img
                width="800px"
                src="../../../src/assets/event/instruction.png"
              ></v-img>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div class="container-block-title">Содержание события</div>
        <div>
          <v-text-field
            label="Заголовок"
            required
            type="text"
            outlined
            :rules="rules"
            counter
            v-model="event.name"
            maxlength="100"
          ></v-text-field>
        </div>
        <div class="d-flex">
          <!-- <v-textarea
                label="Описание события"
                required
                type="text"
                outlined
                :rules="rules"
                no-resize
                 v-model="event.description"
                rows="6"
             ></v-textarea> -->
          <div
            style="margin-bottom: 30px"
            class="trumbowyg-title-box"
            :class="validText ? '' : 'trumbowyg-title-box-error'"
          >
            <div class="trumbowyg-title-box-text">Описание события</div>
            <trumbowyg
              v-model="event.description"
              :config="{ semantic: false }"
            ></trumbowyg>
          </div>
          <div style="position: relative">
            <v-icon
              @mouseover="openInfoDesc($event)"
              @mouseleave="showInfoDesc = false"
              class="icon-information"
              color="var(--app-dark-blue-1)"
              >mdi-information</v-icon
            >
            <v-menu
              v-model="showInfoDesc"
              :position-x="xDesc"
              :position-y="yDesc"
              absolute
              offset-y
            >
              <v-card>
                <div class="menu-container">
                  <div class="menu-container-title">Описание события</div>
                  <div class="menu-container-text">
                    Отображается на экране детальной информации события
                  </div>
                  <v-img
                    src="../../../src/assets/event/descriptionEvent.png"
                  ></v-img>
                </div>
              </v-card>
            </v-menu>
          </div>
        </div>
        <div class="d-flex">
          <v-textarea
            label="Описание при предварительном просмотре"
            required
            type="text"
            outlined
            :rules="rules"
            v-model="event.shortDescription"
            no-resize
            rows="3"
          ></v-textarea>
          <div style="position: relative">
            <v-icon
              @mouseover="openInfoShort($event)"
              @mouseleave="showInfoShort = false"
              class="icon-information"
              color="var(--app-dark-blue-1)"
              >mdi-information</v-icon
            >
            <v-menu
              v-model="showInfoShort"
              :position-x="xShort"
              :position-y="yShort"
              absolute
              offset-y
            >
              <v-card>
                <div class="menu-container">
                  <div class="menu-container-title">
                    Описание при предварительном просмотре
                  </div>
                  <div class="menu-container-text">
                    Отображается при предварительном просмотре в общем списке
                    событий
                  </div>
                  <v-img
                    src="../../../src/assets/event/shortDescription.png"
                  ></v-img>
                </div>
              </v-card>
            </v-menu>
          </div>
        </div>
        <div>
          <v-autocomplete
            v-model="event.regions"
            :items="regions"
            label="Регионы, которые получат уведомление о событии"
            multiple
            small-chips
            deletable-chips
            outlined
            item-text="name"
            :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
          >
            <template v-slot:item="{ attrs, item }">
              <template v-if="item.name !== 'Все регионы'">
                <v-list-item
                :disabled="allRegions"
                @click="multipleSelection(item)"
              >
                <v-checkbox
                  style="
                    margin-top: 16px !important;
                    padding-top: 4px !important;
                  "
                  :disabled="allRegions"
                  v-model="attrs.inputValue"
                ></v-checkbox>

                {{ item.name }}
              </v-list-item>
              </template>
              <template v-else style="width: 100%">
                 <v-list-item
                  @click.stop="toggle"
                  style="
                    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
                    width: 100%;
                  "
                >
                  <v-checkbox
                    style="
                      margin-top: 16px !important;
                      padding-top: 4px !important;
                    "
                    v-model="allRegions"
                    @click="toggle"
                  ></v-checkbox>
                  <v-list-item-content>
                    <v-list-item-title>Все регионы</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
        
            </template>
          </v-autocomplete>
        </div>

        <div class="d-flex">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newDate"
                outlined
                :rules="rules"
                readonly
                label="Дата события"
                v-bind="attrs"
                v-on="on"
                ref="date_input"
                style="margin-right: 20px"
              ></v-text-field>
            </template>

            <v-card class="d-flex">
              <div class="d-flex">
                <!-- :min="new Date().toISOString().substr(0, 10)" -->
                <v-date-picker
                  v-if="menu"
                  locale="ru-Ru"
                  color="var(--app-dark-blue-1)"
                  v-model="pickDate"
                  first-day-of-week="1"
                ></v-date-picker>
              </div>
              <v-time-picker
                v-if="!event.hideEventTime"
                format="24hr"
                color="var(--app-dark-blue-1)"
                scrollable
                :disabled="!pickDate"
                v-model="pickDateTime"
                width="290"
              ></v-time-picker>
              <!-- :allowed-hours="checkTimeHour"
                :allowed-minutes="checkTimeMinute" -->
            </v-card>
          </v-menu>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newDatePublish"
                outlined
                :rules="rules"
                readonly
                label="Дата публикации"
                v-bind="attrs"
                v-on="on"
                ref="date_input"
                style="margin-left: 20px"
              ></v-text-field>
            </template>
            <v-card class="d-flex">
              <div class="d-flex">
                <v-date-picker
                  v-if="menu2"
                  locale="ru-Ru"
                  color="var(--app-dark-blue-1)"
                  v-model="pickDatePublish"
                  first-day-of-week="1"
                ></v-date-picker>
              </div>
              <v-time-picker
                format="24hr"
                color="var(--app-dark-blue-1)"
                scrollable
                :disabled="!pickDatePublish"
                v-model="pickDateTimePublish"
                width="290"
              ></v-time-picker>
              <!-- :allowed-hours="checkTimeHourSecond"
                :allowed-minutes="checkTimeMinuteSecond" -->
            </v-card>
          </v-menu>
        </div>
        <div>
          <v-text-field
            label="Место события"
            type="text"
            outlined
            v-model="event.place"
          ></v-text-field>
        </div>
        <div>
          <v-select
            label="Тип события"
            outlined
            :items="eventTypes"
            item-text="text"
            item-value="value"
            :menu-props="{ bottom: true, offsetY: true }"
            v-model="event.eventType"
            :rules="rules"
          ></v-select>
        </div>
        <div>
          <v-text-field
            label="Ссылка на событие"
            required
            type="text"
            outlined
            :rules="rules"
            v-model="event.link"
          ></v-text-field>
        </div>
      </div>
    </v-form>

    <div class="container-block">
      <div class="container-block-title">Вложенный файл</div>

      <div
        class="d-flex justify-space-between"
        v-for="item in files"
        :key="item.id"
      >
        <div style="width: 47%">
          <v-text-field
            label="Название"
            required
            type="text"
            outlined
            v-model="item.name"
          ></v-text-field>
        </div>
        <div
          class="container-block-file-preview"
          v-if="typeof item.file == 'string'"
        >
          <v-icon> mdi-file-pdf-box </v-icon>
          <a style="margin-left: 8px" target="_blank" :href="item.file">{{
            item.name
          }}</a>
          <v-icon
            color="var(--app-red-1)"
            style="margin-left: 8px"
            @click="item.file = null"
          >
            mdi-delete-outline
          </v-icon>
        </div>
        <div style="width: 47%" v-else>
          <v-file-input
            outlined
            v-model="item.file"
            label="Прикрепите файл pdf"
            :rules="[
              (value) =>
                (value && value.size < 104857600) || 'Весом до 100 мб.',
            ]"
            accept="application/pdf,application/vnd.ms-excel"
          ></v-file-input>
        </div>
      </div>

      <div @click="addFile" class="container-block-gallery-button">
        Добавить файл
      </div>
    </div>
    <div class="container-block">
      <div class="container-block-title">Настройки события</div>
      <div class="d-flex align-center">
        <v-switch
          v-model="event.hideEventTime"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Отображать только дату события</span>
      </div>
      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="event.isTimezoneRequired"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Отображать время согласно региону</span>
      </div>
      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="event.toShowInConference"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Выводить на сайте конференции</span>
      </div>
    </div>

    <div class="container-block">
      <div class="container-block-title">Параметры уведомлений</div>
      <div class="d-flex align-center">
        <v-switch
          v-model="event.toSendPush"
          color="var(--app-green-1)"
          @change="infoPush"
          hide-details
        ></v-switch>
        <span class="switch-label"
          >Рассылка уведомления при публикации события</span
        >
      </div>
      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="event.toSendPushWeekBefore"
          @change="infoPush"
          color="var(--app-green-1)"
          hide-details
        ></v-switch>
        <span class="switch-label"
          >Рассылка уведомления за неделю до начала события</span
        >
      </div>
      <v-form lazy-validation ref="sendPush">
        <v-text-field
          v-if="event.toSendPush || event.toSendPushWeekBefore"
          label="Заголовок пуша"
          required
          type="text"
          outlined
          :rules="rules"
          v-model="event.pushTitle"
          counter
          maxlength="65"
        ></v-text-field>
        <v-text-field
          v-if="event.toSendPush || event.toSendPushWeekBefore"
          label="Описание пуша"
          required
          type="text"
          outlined
          :rules="rules"
          v-model="event.pushDescription"
          counter
          maxlength="240"
        ></v-text-field>
      </v-form>
      <!-- <div class="d-flex align-center">
                <v-switch
                    v-model="event.isTimezoneRequired"
                color="var(--app-green-1)"
                ></v-switch>
                <span class="switch-label">Учитывать временные зоны</span>
            </div> -->
    </div>

    <div class="container-block">
      <div class="container-block-title">Параметры регистрации на событие</div>
      <div class="d-flex align-center mb-2">
        <v-switch
          v-model="event.isRegistrationRequired"
          color="var(--app-green-1)"
          hide-details
        ></v-switch>
        <span class="switch-label"
          >Требуется регистрация на событие (Отображать кнопку «Пойду»)</span
        >
      </div>

      <div class="d-flex align-center">
        <v-switch
          v-model="event.isRegistrationRequiredAndroid"
          color="var(--app-green-1)"
          hide-details
        ></v-switch>
        <span class="switch-label"
          >Регистрация только для пользователей андроид</span
        >
      </div>

      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="event.isRegistrationFromMobile"
          color="var(--app-green-1)"
          hide-details
        ></v-switch>
        <span class="switch-label"
          >Регистрация через мобильное приложение
        </span>
      </div>
      <div v-if="event.isRegistrationFromMobile">
        <div class="d-flex align-center mt-4">
          <v-switch
            :disabled="!event.isRegistrationRequired"
            v-model="event.isPhotoRequired"
            color="var(--app-green-1)"
            hide-details
          ></v-switch>
          <span
            :style="!event.isRegistrationRequired ? { color: '#0000009a' } : ''"
            class="switch-label"
            >Требуется прикрепить фотографию
          </span>
        </div>
        <div class="d-flex align-center mt-4">
          <v-switch
            :disabled="!event.isRegistrationRequired"
            v-model="event.isCOVIDCertificateRequired"
            color="var(--app-green-1)"
            hide-details
          ></v-switch>
          <span
            :style="!event.isRegistrationRequired ? { color: '#0000009a' } : ''"
            class="switch-label"
            >Требуется прикрепить документ</span
          >
        </div>
        <div class="d-flex align-center mt-4">
          <v-switch
            v-model="event.isUserDataRequired"
            color="var(--app-green-1)"
            hide-details
          ></v-switch>
          <span class="switch-label">
            Отображать поля ввода паспортных данных и даты рождения при
            регистрации на событие</span
          >
        </div>
      </div>
      <div v-else>
        <v-text-field
          label="Ссылка на регистрацию"
          required
          type="text"
          outlined
          style="margin-top: 19px"
          :rules="rules"
          v-model="event.registrationLink"
        ></v-text-field>
      </div>
    </div>

    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Главное изображение</div>

      <v-file-input
        accept="image/*"
        outlined
        :rules="[
          (value) =>
            (value && value.size < 104857600) ||
            'Размер изображения не больше 100 мб',
        ]"
        hint="Максимальный размер изображения 100 мб"
        persistent-hint
        v-model="newImage"
        @change="previewImage"
        label="Прикрепить изображение"
      ></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div></div>

    <div v-if="newImage" class="container-block" style="width: 100%">
      <div class="container-block-title">Кадрировать изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px" v-if="newImage">
              <td class="text-left">Главное изображение</td>
              <td class="text-left">Отображается внутри события</td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageMobile"
                  @click="openMobileImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img
                    @click="openMobileImg(false)"
                    class="table-img"
                    :src="finishImageMobile"
                  />
                  <v-btn
                    outlined
                    @click="openMobileImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageTablet"
                  @click="openTabletImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img
                    @click="openTabletImg(false)"
                    class="table-img"
                    :src="finishImageTablet"
                  />
                  <v-btn
                    outlined
                    @click="openTabletImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogMobile"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperMobail"
                  :src="imgSrc"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 343,
                    height: 208,
                  }"
                  image-restriction="stencil"
                  @change="onChangeMobile"
                />
              </div>

              <div v-if="resultImageMobile">
                <img
                  width="343px"
                  height="208px"
                  style="margin-left: 30px"
                  :src="resultImageMobile"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogTablet"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="">
              <div style="width: 100%; height: 200px">
                <cropper
                  ref="cropperTablet"
                  :src="imgSrc"
                  style="width: 100%; height: 300px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 658,
                    height: 300,
                  }"
                  image-restriction="stencil"
                  @change="onChangeTablet"
                />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTablet">
                <img width="658px" height="300px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn
          @click="saveEvent"
          :loading="sendForm"
          style="width: auto !important"
          class="button-accept"
        >
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn
          @click="dialogDelete = true"
          outlined
          :disabled="sendForm"
          style="width: auto !important"
          color="var(--app-red-1)"
          class="button-accept-outlined"
        >
          Удалить
        </v-btn>
      </div>
    </div>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить событие?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="dialogDelete = false"
            style="width: 120px"
            outlined
            color="var(--app-green-1)"
          >
            Нет
          </v-btn>
          <v-btn
            @click="deleteEvent"
            style="width: 120px"
            outlined
            color="var(--app-red-1)"
          >
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    event: {
      isRegistrationRequired: false,
      isPhotoRequired: false,
      isCOVIDCertificateRequired: false,
      toSendPush: false,
      toSendPushWeekBefore: false,
      hideEventTime: false,
      eventType: "online_offline",
    },

    dates: [],
    newDate: null,
    newDatePublish: null,
    pickDate: null,
    pickDateTime: "00:00",
    pickDateTimePublish: "00:00",
    pickDatePublish: null,
    text: "",
    validText: true,
    regions: [],
    errImages: false,
    errImagesMain: false,
    dialogMobile: false,
    dialogDelete: false,
    dialogTablet: false,
    dialogInfo: false,

    dateFormatted: null,
    menu: false,
    menu2: false,

    sections: [],
    eventTypes: [
      { text: "Онлайн/Оффлайн", value: "online_offline" },
      { text: "Онлайн", value: "online" },
      { text: "Оффлайн", value: "offline" },
    ],

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    imgSrc: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    smartphoneMainImage: null,
    tabletMainImage: null,
    formData: new FormData(),

    files: [{ id: 1, name: "", file: null }],
    showInfoDesc: false,
    xDesc: null,
    yDesc: null,

    showInfoShort: false,
    xShort: null,
    yShort: null,
    allRegions: false,
    sendForm: false,
  }),

  methods: {
    multipleSelection(item) {
      let newObj = [];
      newObj = this.event.regions.filter((i) => item == i);

      if (newObj.length > 0) {
        const newArr = this.event.regions.filter((it) => newObj[0] != it);
        this.event.regions = newArr;
      } else {
        this.event.regions.push(item);
      }
    },
    infoPush() {
      if (this.event && !this.event.pushTitle && !this.event.pushDescription) {
        this.event.pushTitle = this.event.name;
        this.event.pushDescription = this.event.shortDescription;
      }
    },
    checkTimeHour(hour) {
      if (new Date().toISOString().substr(0, 10) == this.pickDate) {
        return hour >= new Date().getHours();
      } else {
        return hour + 1;
      }
    },
    checkTimeMinute(minute) {
      if (
        new Date().toISOString().substr(0, 10) == this.pickDate &&
        new Date().getHours() == parseInt(this.pickDateTime.substr(0, 2))
      ) {
        return minute >= new Date().getMinutes() && minute % 1 === 0;
      } else {
        return minute % 1 === 0;
      }
    },
    checkTimeHourSecond(hour) {
      if (new Date().toISOString().substr(0, 10) == this.pickDatePublish) {
        return hour >= new Date().getHours();
      } else {
        return hour + 1;
      }
    },
    checkTimeMinuteSecond(minute) {
      if (
        new Date().toISOString().substr(0, 10) == this.pickDatePublish &&
        new Date().getHours() == parseInt(this.pickDateTimePublish.substr(0, 2))
      ) {
        return minute >= new Date().getMinutes() && minute % 1 === 0;
      } else {
        return minute % 1 === 0;
      }
    },
    // toggle () {

    //     if (this.event.regions.length === this.regions.length) {
    //         this.event.regions = []
    //         this.allRegions = false
    //     } else {
    //         this.event.regions = this.regions.slice()
    //         this.allRegions = true
    //     }

    // },
    deleteEvent() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/event", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            eventId: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({ name: "Events" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    openInfoDesc(e) {
      e.preventDefault();
      this.xDesc = e.clientX + 10;
      this.yDesc = e.clientY + 10;
      this.showInfoDesc = true;
    },
    openInfoShort(e) {
      e.preventDefault();
      this.xShort = e.clientX + 10;
      this.yShort = e.clientY + 10;
      this.showInfoShort = true;
    },
    addFile() {
      const newObj = {
        name: "",
        file: null,
      };
      this.files.push(newObj);
    },
    getAppSections() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/appSection/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.sections = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
    },

    openMobileImg() {
      this.dialogMobile = true;
      setTimeout(() => {
        this.$refs.cropperMobail.refresh();
      }, 500);

      this.errImages = false;
    },
    openTabletImg() {
      this.dialogTablet = true;
      setTimeout(() => {
        this.$refs.cropperTablet.refresh();
      }, 500);

      this.errImages = false;
    },
    closeTabletImg() {
      this.finishImageTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("tabletImage")) {
            this.formData.delete("tabletImage");
          }
          this.formData.append("tabletImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMainImage = true;
    },

    closeMobileImg() {
      this.finishImageMobile = this.resultImageMobile;
      this.dialogMobile = false;
      const { canvas } = this.$refs.cropperMobail.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("smartphoneImage")) {
            this.formData.delete("smartphoneImage");
          }
          this.formData.append("smartphoneImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMainImage = true;
    },

    back() {
      this.$router.push({ name: "Events" });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },

    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },

    getRigionsList() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/region/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.regions = res.data.items;
          this.getEvent();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getEvent() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/event", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            eventId: this.$route.params.id,
          },
        })
        .then((res) => {
          this.event = {
            eventType: "online_offline",
            hideEventTime: false,
            ...res.data,
          };
          this.event.eventType = this.normalizeEventType(this.event.eventType);
          this.files = res.data.files;

          this.newImage = this.event.originalImage;
          this.imgSrc = this.event.originalImage;
          this.smartphoneMainImage = this.event.smartphoneImage;
          this.tabletMainImage = this.event.tabletImage;
          this.event.smartphoneImage
            ? (this.finishImageMobile = this.event.smartphoneImage)
            : "";
          this.event.tabletImage
            ? (this.finishImageTablet = this.event.tabletImage)
            : "";
          const date = new Date(this.event.plannedDate);
          this.pickDate = new Date(
            this.event.plannedDate - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          let hour = date.getHours();
          let minute = date.getMinutes();
          if (hour < 10) {
            hour = `0${hour}`;
          }
          if (minute < 10) {
            minute = `0${minute}`;
          }
          this.pickDateTime = `${hour}:${minute}`;

          const datePublish = new Date(this.event.datePublish);
          this.pickDatePublish = new Date(
            this.event.datePublish - datePublish.getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          let hourPublish = datePublish.getHours();
          let minutePublish = datePublish.getMinutes();
          if (hourPublish < 10) {
            hourPublish = `0${hourPublish}`;
          }
          if (minutePublish < 10) {
            minutePublish = `0${minutePublish}`;
          }
          this.pickDateTimePublish = `${hourPublish}:${minutePublish}`;
         
          if (this.regions.length == this.event.regions.length) {
            this.allRegions = true;
         
            this.event.regions = [{ name: "Все регионы" }];
          }
          this.regions.unshift({ name: "Все регионы" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    toggle() {
      this.allRegions = !this.allRegions;
      if (this.allRegions) {
        this.event.regions = [{ name: "Все регионы" }];
      } else {
        this.event.regions = [];
      }
    },
    normalizeEventType(type) {
      const eventTypeMap = {
        "Онлайн/Оффлайн": "online_offline",
        Онлайн: "online",
        Оффлайн: "offline",
      };

      return eventTypeMap[type] || type || "online_offline";
    },
    saveEvent() {
      if (this.$refs.formFirst.validate() && this.validText) {
        const checkPush =
          this.event.toSendPush || this.event.toSendPushWeekBefore
            ? this.$refs.sendPush.validate()
            : true;
        if (checkPush) {
          if (this.newImage) {
            if (this.smartphoneMainImage && this.tabletMainImage) {
              this.errImages = false;
              this.sendForm = true;
              const validDate =
                this.pickDate +
                "T" +
                (this.event.hideEventTime ? "00:00" : this.pickDateTime);
              const date = new Date(validDate).getTime();
              const validDatePublish =
                this.pickDatePublish + "T" + this.pickDateTimePublish;
              const datePublish = new Date(validDatePublish).getTime();

              const newArr = Array.from(this.files).filter((item) => item.file);
              const newArrFiles = newArr
                .map((i) => {
                  return typeof i.file == "object" ? i.file : null;
                })
                .filter((el) => {
                  return el != null;
                });
              const newArrNames = newArr.map((i) => {
                if (typeof i.file == "object") {
                  i.file = "";
                  return i;
                } else {
                  return i;
                }
              });

              this.formData.append("eventId", this.event.id);
              this.formData.append("name", this.event.name);
              this.formData.append("description", this.event.description);
              this.formData.append(
                "shortDescription",
                this.event.shortDescription
              );
              this.formData.append("place", this.event.place || "");
              this.formData.append("hideEventTime", this.event.hideEventTime);
              this.formData.append("eventType", this.event.eventType);
              this.formData.append("link", this.event.link);
              if (this.allRegions) {
                this.formData.append("regions", JSON.stringify(this.regions.filter((i) => i.name !== "Все регионы")));
              } else {
                this.formData.append(
                  "regions",
                  JSON.stringify(this.event.regions)
                );
              }

              this.formData.append("plannedDate", date);
              this.formData.append("datePublish", datePublish);
              this.formData.append("toSendPush", this.event.toSendPush);
              this.formData.append(
                "toSendPushWeekBefore",
                this.event.toSendPushWeekBefore
              );
              if (this.event.toSendPush || this.event.toSendPushWeekBefore) {
                this.formData.append("pushTitle", this.event.pushTitle);
                this.formData.append(
                  "pushDescription",
                  this.event.pushDescription
                );
              }
              this.formData.append(
                "isRegistrationRequired",
                this.event.isRegistrationRequired
              );

              this.formData.append(
                "isRegistrationRequiredAndroid",
                this.event.isRegistrationRequiredAndroid
              );
              this.formData.append(
                "isUserDataRequired",
                this.event.isUserDataRequired
              );

              this.formData.append(
                "isPhotoRequired",
                this.event.isPhotoRequired
              );
              this.formData.append(
                "isTimezoneRequired",
                this.event.isTimezoneRequired
              );
              this.formData.append(
                "toShowInConference",
                this.event.toShowInConference
              );
              this.formData.append(
                "isCOVIDCertificateRequired",
                this.event.isCOVIDCertificateRequired
              );
              for (let index = 0; index < newArrFiles.length; index++) {
                const element = newArrFiles[index];
                this.formData.append("files", element);
              }

              this.formData.append("files", JSON.stringify(newArrNames));

              this.formData.append("originalImage", this.newImage || null);
              this.formData.append(
                "isRegistrationFromMobile",
                this.event.isRegistrationFromMobile
              );
              this.formData.append(
                "registrationLink",
                this.event.registrationLink || null
              );

              this.$axios
                .post(
                  this.$store.getters.apiAdminPanelV2 + "/event",
                  this.formData,
                  {
                    headers: {
                      authorization: this.$store.getters.adminPanelHeaderAuth,
                    },
                  }
                )
                .then(() => {
                  this.sendForm = false;
                  this.$router.push({ name: "Events" });
                })
                .catch((err) => {
                  this.sendForm = false;
                  this.$store.commit("errorSet", true);
                  this.$store.commit("errorTextSet", err);
                });
            } else {
              this.errImages = true;
            }
          } else {
            this.errImagesMain = true;
          }
        }
      } else {
        if (!this.event.description) {
          this.validText = false;
        }
      }
    },
  },
  created() {
    this.getAppSections();
    this.getRigionsList();
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
    pickDate() {
      const date = this.formatDate(this.pickDate);
      this.newDate = this.event.hideEventTime
        ? date
        : date + " " + this.pickDateTime;
    },
    pickDateTime() {
      if (this.pickDate) {
        const date = this.formatDate(this.pickDate);
        this.newDate = this.event.hideEventTime
          ? date
          : date + " " + this.pickDateTime;
      }
    },
    "event.hideEventTime"() {
      if (this.pickDate) {
        const date = this.formatDate(this.pickDate);
        this.newDate = this.event.hideEventTime
          ? date
          : date + " " + this.pickDateTime;
      }
    },
    pickDatePublish() {
      const date = this.formatDate(this.pickDatePublish);
      this.newDatePublish = date + " " + this.pickDateTimePublish;
    },

    pickDateTimePublish() {
      if (this.pickDatePublish) {
        const date = this.formatDate(this.pickDatePublish);
        this.newDatePublish = date + " " + this.pickDateTimePublish;
      }
    },
    "event.isRegistrationRequired"() {
      if (!this.event.isRegistrationRequired) {
        this.event.isPhotoRequired = false;
        this.event.isCOVIDCertificateRequired = false;
      }
    },
    "event.regions"() {
      if (this.event.regions.length === 0) {
        this.allRegions = false;
      }
    },
    "event.description"() {
      if (this.event.description) {
        this.validText = true;
      } else {
        this.validText = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.trumbowyg-title-box {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 4px;
  padding: 2px;
}

.trumbowyg-title-box-error {
  border: 2px solid red !important;
}

.trumbowyg-title-box-text {
  font-size: 16px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  height: 50px;
}

.switch-label {
  font-size: 16px;

  margin-bottom: 2px;
}

.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }

    .container-main-checkbox {
      border: 1px solid rgba(0, 0, 0, 0.42);
      border-radius: 4px;
      padding-top: 20px;
      padding-left: 12px;
      margin-top: 0px !important;
    }

    .container-block-file-preview {
      width: 47%;
      height: 56px;
      display: flex;
      align-items: center;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.icon-information {
  position: absolute;
  left: 16px;
}
</style>
